/* Confirmation after a successful add; the browser dialog provides focus trapping. */
(() => {
  const dialog = document.getElementById('SunnyRequestAdded');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const productText = dialog.querySelector('[data-request-added-product]');
  let returnFocus = null;

  dialog.querySelector('[data-request-continue]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    document.body.classList.remove('sunny-request-popup-open');
    if (returnFocus?.isConnected) returnFocus.focus();
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });

  window.sunnyRequestAdded = (response, opener) => {
    const item = response.items?.[0] || response;
    const name = item.product_title || item.title || '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? ` — ${item.variant_title}` : '';
    productText.textContent = `${name}${variant}`;
    returnFocus = opener;
    // Shopify renders this fragment from the same successful add request.
    const html = response.sections?.['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    if (html && bubble) {
      const fragment = new DOMParser().parseFromString(html, 'text/html');
      const content = fragment.querySelector('.shopify-section');
      if (content) bubble.innerHTML = content.innerHTML;
    }
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('sunny-request-popup-open');
  };
})();
